import { Record, toString, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Scope_get_Decoder, Users_projectsDecoder, Scope_$reflection, Users_Project_$reflection, EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F, EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static, EquipmentTypes_EquipmentType_$reflection, Disciplines_Discipline_$reflection, Activities_Activity_$reflection, Actions_Action_$reflection, ActionTypes_ActionType_$reflection, Documents_Document_$reflection, Tags_Tag_$reflection, Subsystems_Subsystem_$reflection, Systems_Sys_$reflection, ProductionUnits_ProductionUnit_$reflection, ProductionUnitTypes_ProductionUnitType_$reflection, Locations_Location_$reflection, Areas_Area_$reflection, Modules_Module_$reflection, Facilities_Facility_$reflection } from "./ServerTypes.fs.js";
import { option_type, record_type, int32_type, list_type, bool_type, string_type, class_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { orElse, defaultArgWith, map2, map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { DomainEntities_tryParse_Z721C83C5, Maturity_$reflection, Criticality_$reflection, Condition_$reflection, Status_$reflection, DomainEntities_$reflection, Action_Category_$reflection, DomainEntities } from "./DomainEvents.fs.js";
import { FSharpMap__TryFind, filter, add, ofList, toList, FSharpMap__get_IsEmpty, ofArray as ofArray_1, empty } from "./fable_modules/fable-library-js.4.24.0/Map.js";
import { uncurry2, stringHash, safeHash, equals, comparePrimitives } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Types_Scope__Scope_get_HasAccessToAdmin, Feliz_Router_Router__Router_navigatePath_Static_Z400814D9, Map_merge, Feliz_Router_Router__Router_formatPath_Static_Z400814D9, Feliz_Router_Router__Router_getCurrentParsedUrl_Static, StringPatterns_$007CStartsWithExtract$007C_$007C, System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5, System_Boolean__Boolean_tryParse_Static_Z721C83C5, EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5, EPM_Domain_Events_Action_Category__Category_tryParse_Static_Z721C83C5, EPM_Domain_Events_Criticality__Criticality_tryParse_Static_Z721C83C5, EPM_Domain_Events_Condition__Condition_tryParse_Static_Z721C83C5, EPM_Domain_Events_Status__Status_tryParse_Static_Z721C83C5, System_Guid__Guid_tryParse_Static_Z721C83C5, EPM_Domain_Events_Maturity__Maturity_ToUrlString, EPM_Domain_Events_Action_Category__Category_ToUrlString, attributesToUrl, labelsToUrl } from "./Prelude.fs.js";
import { toString as toString_1 } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { split, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { exists, append, singleton, empty as empty_2, contains, tryPick, map as map_3, choose as choose_1, head, tail, isEmpty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { choose, map as map_2 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { FSharpSet__get_IsEmpty, ofArray as ofArray_2, empty as empty_1 } from "./fable_modules/fable-library-js.4.24.0/Set.js";
import { List_except } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";
import { list as list_4, guid, string, int, object } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { option as option_17, list as list_5, guid as guid_1, object as object_1 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";

export class DomainEntity extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Facility", "Module", "Area", "Location", "ProductionUnitType", "ProductionUnit", "System", "Subsystem", "Tag", "Document", "ActionType", "Action", "Activity", "Discipline", "EquipmentType"];
    }
}

export function DomainEntity_$reflection() {
    return union_type("EPM.App.DomainEntity", [], DomainEntity, () => [[["Item", Facilities_Facility_$reflection()]], [["Item", Modules_Module_$reflection()]], [["Item", Areas_Area_$reflection()]], [["Item", Locations_Location_$reflection()]], [["Item", ProductionUnitTypes_ProductionUnitType_$reflection()]], [["Item", ProductionUnits_ProductionUnit_$reflection()]], [["Item", Systems_Sys_$reflection()]], [["Item", Subsystems_Subsystem_$reflection()]], [["Item", Tags_Tag_$reflection()]], [["Item", Documents_Document_$reflection()]], [["Item", ActionTypes_ActionType_$reflection()]], [["Item", Actions_Action_$reflection()]], [["Item", Activities_Activity_$reflection()]], [["Item", Disciplines_Discipline_$reflection()]], [["Item", EquipmentTypes_EquipmentType_$reflection()]]]);
}

export function DomainEntity__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Id;
        case 2:
            return this$.fields[0].Id;
        case 3:
            return this$.fields[0].Id;
        case 4:
            return this$.fields[0].Id;
        case 5:
            return this$.fields[0].Id;
        case 6:
            return this$.fields[0].Id;
        case 7:
            return this$.fields[0].Id;
        case 8:
            return this$.fields[0].Id;
        case 9:
            return this$.fields[0].Id;
        case 11:
            return this$.fields[0].Id;
        case 10:
            return this$.fields[0].Id;
        case 12:
            return this$.fields[0].Id;
        case 13:
            return this$.fields[0].Id;
        case 14:
            return this$.fields[0].Id;
        default:
            return this$.fields[0].Id;
    }
}

export function DomainEntity__get_Name(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Name;
        case 2:
            return this$.fields[0].Name;
        case 3:
            return this$.fields[0].Name;
        case 4:
            return this$.fields[0].Name;
        case 5:
            return this$.fields[0].Name;
        case 6:
            return this$.fields[0].Name;
        case 7:
            return this$.fields[0].Name;
        case 8:
            return this$.fields[0].Name;
        case 9:
            return this$.fields[0].Name;
        case 10:
            return this$.fields[0].Name;
        case 11:
            return this$.fields[0].Name;
        case 12:
            return defaultArg(this$.fields[0].Name, "?");
        case 13:
            return this$.fields[0].Name;
        case 14:
            return this$.fields[0].Name;
        default:
            return this$.fields[0].Name;
    }
}

export function DomainEntity__get_Detail(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Detail;
        case 2:
            return this$.fields[0].Detail;
        case 3:
            return undefined;
        case 4:
            return undefined;
        case 5:
            return this$.fields[0].Detail;
        case 6:
            return this$.fields[0].Detail;
        case 7:
            return this$.fields[0].Detail;
        case 8:
            return this$.fields[0].Detail;
        case 9:
            return this$.fields[0].Detail;
        case 10:
            return this$.fields[0].Detail;
        case 11:
            return this$.fields[0].Detail;
        case 12:
            return this$.fields[0].Detail;
        case 13:
            return undefined;
        case 14:
            return undefined;
        default:
            return undefined;
    }
}

export function DomainEntity__get_DomainEntity(this$) {
    switch (this$.tag) {
        case 1:
            return new DomainEntities(6, []);
        case 2:
            return new DomainEntities(7, []);
        case 3:
            return new DomainEntities(8, []);
        case 4:
            return new DomainEntities(14, []);
        case 5:
            return new DomainEntities(13, []);
        case 6:
            return new DomainEntities(1, []);
        case 7:
            return new DomainEntities(2, []);
        case 8:
            return new DomainEntities(0, []);
        case 9:
            return new DomainEntities(9, []);
        case 10:
            return new DomainEntities(12, []);
        case 11:
            return new DomainEntities(11, []);
        case 12:
            return new DomainEntities(5, []);
        case 13:
            return new DomainEntities(4, []);
        case 14:
            return new DomainEntities(10, []);
        default:
            return new DomainEntities(3, []);
    }
}

export function DomainEntity__get_Labels(this$) {
    switch (this$.tag) {
        case 1:
            return empty({
                Compare: comparePrimitives,
            });
        case 2:
            return empty({
                Compare: comparePrimitives,
            });
        case 3:
            return empty({
                Compare: comparePrimitives,
            });
        case 4:
            return empty({
                Compare: comparePrimitives,
            });
        case 5:
            return empty({
                Compare: comparePrimitives,
            });
        case 6:
            return empty({
                Compare: comparePrimitives,
            });
        case 7:
            return empty({
                Compare: comparePrimitives,
            });
        case 8:
            return this$.fields[0].Labels;
        case 9:
            return this$.fields[0].Labels;
        case 10:
            return empty({
                Compare: comparePrimitives,
            });
        case 11:
            return this$.fields[0].Labels;
        case 12:
            return this$.fields[0].Labels;
        case 13:
            return empty({
                Compare: comparePrimitives,
            });
        case 14:
            return empty({
                Compare: comparePrimitives,
            });
        default:
            return empty({
                Compare: comparePrimitives,
            });
    }
}

export function EntityType__ToProperPluralString(this$) {
    switch (this$) {
        case "system":
            return "Systems";
        case "subsystem":
            return "Subsystems";
        case "facility":
            return "Facilities";
        case "activity":
            return "Activities";
        case "certification":
            return "Certificates";
        case "punchList":
            return "Punch Lists";
        case "documentTracking":
            return "Document Trackings";
        case "preservation":
            return "Preservation";
        case "technicalQuery":
            return "Technical Queries";
        case "nonConformanceReport":
            return "Non-Conformance Reports";
        case "module":
            return "Modules";
        case "area":
            return "Areas";
        case "location":
            return "Locations";
        case "document":
            return "Documents";
        case "productionUnit":
            return "Production Units";
        case "scopeOfWork":
            return "Scope of Work";
        default:
            return "Tags";
    }
}

export function EntityType__ToProperString(this$) {
    switch (this$) {
        case "system":
            return "System";
        case "subsystem":
            return "Subsystem";
        case "facility":
            return "Facility";
        case "activity":
            return "Activity";
        case "certification":
            return "Certificate";
        case "punchList":
            return "Punch List";
        case "documentTracking":
            return "Document Tracking";
        case "preservation":
            return "Preservation";
        case "technicalQuery":
            return "Technical Query";
        case "nonConformanceReport":
            return "Non-Conformance Report";
        case "module":
            return "Module";
        case "area":
            return "Area";
        case "location":
            return "Location";
        case "document":
            return "Document";
        case "productionUnit":
            return "Production Unit";
        case "scopeOfWork":
            return "Scope of Work";
        default:
            return "Tag";
    }
}

export function EntityType__get_DomainEntity(this$) {
    switch (this$) {
        case "system":
            return new DomainEntities(1, []);
        case "subsystem":
            return new DomainEntities(2, []);
        case "facility":
            return new DomainEntities(3, []);
        case "activity":
            return new DomainEntities(5, []);
        case "certification":
            return new DomainEntities(5, []);
        case "punchList":
            return new DomainEntities(5, []);
        case "documentTracking":
            return new DomainEntities(5, []);
        case "preservation":
            return new DomainEntities(5, []);
        case "technicalQuery":
            return new DomainEntities(5, []);
        case "nonConformanceReport":
            return new DomainEntities(5, []);
        case "module":
            return new DomainEntities(6, []);
        case "area":
            return new DomainEntities(7, []);
        case "location":
            return new DomainEntities(8, []);
        case "document":
            return new DomainEntities(9, []);
        case "productionUnit":
            return new DomainEntities(13, []);
        case "scopeOfWork":
            return new DomainEntities(5, []);
        default:
            return new DomainEntities(0, []);
    }
}

export function EntityType__get_IsActivityType(this$) {
    switch (this$) {
        case "activity":
        case "certification":
        case "documentTracking":
        case "punchList":
        case "preservation":
        case "technicalQuery":
        case "nonConformanceReport":
        case "scopeOfWork":
            return true;
        default:
            return false;
    }
}

export function EntityType_tryParse_Z721C83C5(x) {
    switch (x) {
        case "tag":
            return "tag";
        case "system":
            return "system";
        case "subsystem":
            return "subsystem";
        case "facility":
            return "facility";
        case "module":
            return "module";
        case "area":
            return "area";
        case "location":
            return "location";
        case "document":
            return "document";
        case "activity":
            return "activity";
        case "productionUnit":
            return "productionUnit";
        case "certification":
            return "certification";
        case "punchList":
            return "punchList";
        case "documentTracking":
            return "documentTracking";
        case "preservation":
            return "preservation";
        case "technicalQuery":
            return "technicalQuery";
        case "nonConformanceReport":
            return "nonConformanceReport";
        case "scopeOfWork":
            return "scopeOfWork";
        default:
            return undefined;
    }
}

export class Entity extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Facility", "Module", "Area", "Location", "ProductionUnit", "System", "Subsystem", "Tag", "Document", "ScopeOfWork", "Activity"];
    }
}

export function Entity_$reflection() {
    return union_type("EPM.App.Entity", [], Entity, () => [[["Item", Facilities_Facility_$reflection()]], [["Item", Modules_Module_$reflection()]], [["Item", Areas_Area_$reflection()]], [["Item", Locations_Location_$reflection()]], [["Item", ProductionUnits_ProductionUnit_$reflection()]], [["Item", Systems_Sys_$reflection()]], [["Item", Subsystems_Subsystem_$reflection()]], [["Item", Tags_Tag_$reflection()]], [["Item", Documents_Document_$reflection()]], [["Item", Activities_Activity_$reflection()]], [["Item1", Action_Category_$reflection()], ["Item2", Activities_Activity_$reflection()]]]);
}

export function Entity__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Id;
        case 2:
            return this$.fields[0].Id;
        case 3:
            return this$.fields[0].Id;
        case 4:
            return this$.fields[0].Id;
        case 5:
            return this$.fields[0].Id;
        case 6:
            return this$.fields[0].Id;
        case 7:
            return this$.fields[0].Id;
        case 8:
            return this$.fields[0].Id;
        case 10:
            return this$.fields[1].Id;
        case 9:
            return this$.fields[0].Id;
        default:
            return this$.fields[0].Id;
    }
}

export function Entity__get_Name(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Name;
        case 2:
            return this$.fields[0].Name;
        case 3:
            return this$.fields[0].Name;
        case 4:
            return this$.fields[0].Name;
        case 5:
            return this$.fields[0].Name;
        case 6:
            return this$.fields[0].Name;
        case 7:
            return this$.fields[0].Name;
        case 8:
            return this$.fields[0].Name;
        case 10:
            return "Activity Name";
        case 9:
            return "Activity Name";
        default:
            return this$.fields[0].Name;
    }
}

export function Entity__get_Detail(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Detail;
        case 2:
            return this$.fields[0].Detail;
        case 3:
            return undefined;
        case 4:
            return this$.fields[0].Detail;
        case 5:
            return this$.fields[0].Detail;
        case 6:
            return this$.fields[0].Detail;
        case 7:
            return this$.fields[0].Detail;
        case 8:
            return this$.fields[0].Detail;
        case 10:
            return undefined;
        case 9:
            return undefined;
        default:
            return undefined;
    }
}

export function Entity__get_EntityType(this$) {
    switch (this$.tag) {
        case 1:
            return "module";
        case 2:
            return "area";
        case 3:
            return "location";
        case 4:
            return "productionUnit";
        case 5:
            return "system";
        case 6:
            return "subsystem";
        case 7:
            return "tag";
        case 8:
            return "document";
        case 9:
            return "activity";
        case 10: {
            const category = this$.fields[0];
            switch (category.tag) {
                case 1:
                    return "certification";
                case 3:
                    return "documentTracking";
                case 4:
                    return "preservation";
                case 2:
                    return "punchList";
                case 5:
                    return "technicalQuery";
                case 6:
                    return "nonConformanceReport";
                default:
                    return "activity";
            }
        }
        default:
            return "facility";
    }
}

export function Entity__get_DomainEntity(this$) {
    switch (this$.tag) {
        case 1:
            return new DomainEntity(1, [this$.fields[0]]);
        case 2:
            return new DomainEntity(2, [this$.fields[0]]);
        case 3:
            return new DomainEntity(3, [this$.fields[0]]);
        case 4:
            return new DomainEntity(5, [this$.fields[0]]);
        case 5:
            return new DomainEntity(6, [this$.fields[0]]);
        case 6:
            return new DomainEntity(7, [this$.fields[0]]);
        case 7:
            return new DomainEntity(8, [this$.fields[0]]);
        case 8:
            return new DomainEntity(9, [this$.fields[0]]);
        case 10:
            return new DomainEntity(12, [this$.fields[1]]);
        case 9:
            return new DomainEntity(12, [this$.fields[0]]);
        default:
            return new DomainEntity(0, [this$.fields[0]]);
    }
}

export function Entity_FromDomainEntity_Z6268B2B9(domainEntity) {
    switch (domainEntity.tag) {
        case 1:
            return new Entity(1, [domainEntity.fields[0]]);
        case 2:
            return new Entity(2, [domainEntity.fields[0]]);
        case 3:
            return new Entity(3, [domainEntity.fields[0]]);
        case 4:
            return undefined;
        case 5:
            return new Entity(4, [domainEntity.fields[0]]);
        case 6:
            return new Entity(5, [domainEntity.fields[0]]);
        case 7:
            return new Entity(6, [domainEntity.fields[0]]);
        case 8:
            return new Entity(7, [domainEntity.fields[0]]);
        case 9:
            return new Entity(8, [domainEntity.fields[0]]);
        case 10:
            return undefined;
        case 11:
            return undefined;
        case 12:
            return undefined;
        case 13:
            return undefined;
        case 14:
            return undefined;
        default:
            return new Entity(0, [domainEntity.fields[0]]);
    }
}

export class Target extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Facility", "Module", "Area", "Location", "ProductionUnit", "System", "Subsystem", "Tag", "Document"];
    }
}

export function Target_$reflection() {
    return union_type("EPM.App.Target", [], Target, () => [[["Item", Facilities_Facility_$reflection()]], [["Item", Modules_Module_$reflection()]], [["Item", Areas_Area_$reflection()]], [["Item", Locations_Location_$reflection()]], [["Item", ProductionUnits_ProductionUnit_$reflection()]], [["Item", Systems_Sys_$reflection()]], [["Item", Subsystems_Subsystem_$reflection()]], [["Item", Tags_Tag_$reflection()]], [["Item", Documents_Document_$reflection()]]]);
}

export function Target__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Id;
        case 2:
            return this$.fields[0].Id;
        case 3:
            return this$.fields[0].Id;
        case 4:
            return this$.fields[0].Id;
        case 5:
            return this$.fields[0].Id;
        case 6:
            return this$.fields[0].Id;
        case 7:
            return this$.fields[0].Id;
        case 8:
            return this$.fields[0].Id;
        default:
            return this$.fields[0].Id;
    }
}

export function Target__get_Name(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Name;
        case 2:
            return this$.fields[0].Name;
        case 3:
            return this$.fields[0].Name;
        case 4:
            return this$.fields[0].Name;
        case 5:
            return this$.fields[0].Name;
        case 6:
            return this$.fields[0].Name;
        case 7:
            return this$.fields[0].Name;
        case 8:
            return this$.fields[0].Name;
        default:
            return this$.fields[0].Name;
    }
}

export function Target__get_Detail(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Detail;
        case 2:
            return this$.fields[0].Detail;
        case 3:
            return undefined;
        case 4:
            return this$.fields[0].Detail;
        case 5:
            return this$.fields[0].Detail;
        case 6:
            return this$.fields[0].Detail;
        case 7:
            return this$.fields[0].Detail;
        case 8:
            return this$.fields[0].Detail;
        default:
            return undefined;
    }
}

export function Target__get_EntityType(this$) {
    switch (this$.tag) {
        case 1:
            return "module";
        case 2:
            return "area";
        case 3:
            return "location";
        case 4:
            return "productionUnit";
        case 5:
            return "system";
        case 6:
            return "subsystem";
        case 7:
            return "tag";
        case 8:
            return "document";
        default:
            return "facility";
    }
}

export class ActivityDateRange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DoneOn", "DoneBetween", "ExpectedOn", "ExpectedBetween", "FallsBetween", "FallsOn"];
    }
}

export function ActivityDateRange_$reflection() {
    return union_type("EPM.App.ActivityDateRange", [], ActivityDateRange, () => [[["Item", class_type("System.DateTimeOffset")]], [["Item1", class_type("System.DateTimeOffset")], ["Item2", class_type("System.DateTimeOffset")]], [["Item", class_type("System.DateTimeOffset")]], [["Item1", class_type("System.DateTimeOffset")], ["Item2", class_type("System.DateTimeOffset")]], [["Item1", class_type("System.DateTimeOffset")], ["Item2", class_type("System.DateTimeOffset")]], [["Item", class_type("System.DateTimeOffset")]]]);
}

export function SearchKey_labelsKey(domainEntity) {
    return `${"labels"}${toString(domainEntity)}`;
}

export function SearchKey_singleDomainEntityKey(entityType) {
    switch (entityType.tag) {
        case 0:
            return "tagId";
        case 1:
            return "systemId";
        case 2:
            return "subsystemId";
        case 4:
            return "disciplineId";
        case 5:
            return "activityId";
        case 6:
            return "moduleId";
        case 7:
            return "areaId";
        case 8:
            return "locationId";
        case 9:
            return "documentId";
        case 10:
            return "equipmentTypeId";
        case 11:
            return "actionId";
        case 12:
            return "actionTypeId";
        case 13:
            return "productionUnitId";
        case 14:
            return "productionUnitTypeId";
        default:
            return "facilityId";
    }
}

export function SearchKey_tryParseSingleDomainEntityKey(key) {
    switch (key) {
        case "facilityId":
            return new DomainEntities(3, []);
        case "tagId":
            return new DomainEntities(0, []);
        case "systemId":
            return new DomainEntities(1, []);
        case "subsystemId":
            return new DomainEntities(2, []);
        case "disciplineId":
            return new DomainEntities(4, []);
        case "activityId":
            return new DomainEntities(5, []);
        case "moduleId":
            return new DomainEntities(6, []);
        case "areaId":
            return new DomainEntities(7, []);
        case "locationId":
            return new DomainEntities(8, []);
        case "documentId":
            return new DomainEntities(9, []);
        case "equipmentTypeId":
            return new DomainEntities(10, []);
        case "actionId":
            return new DomainEntities(11, []);
        case "actionTypeId":
            return new DomainEntities(12, []);
        case "productionUnitId":
            return new DomainEntities(13, []);
        case "productionUnitTypeId":
            return new DomainEntities(14, []);
        default:
            return undefined;
    }
}

export class InfoPanel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProjectInfoPanel", "EntityInfoPanel"];
    }
}

export function InfoPanel_$reflection() {
    return union_type("EPM.App.InfoPanel", [], InfoPanel, () => [[], [["Item1", class_type("System.Guid")], ["Item2", DomainEntities_$reflection()]]]);
}

export function ProgressStatus__ToProperString(this$) {
    switch (this$) {
        case "behind":
            return "Behind";
        case "toDo":
            return "To Do";
        case "overHours":
            return "Over Hours";
        default:
            return "Completed";
    }
}

export function ProgressStatus_tryParse_Z721C83C5(x) {
    switch (x) {
        case "completed":
            return "completed";
        case "behind":
            return "behind";
        case "toDo":
            return "toDo";
        case "overHours":
            return "overHours";
        default:
            return undefined;
    }
}

export class SearchParams extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SearchType", "Query", "EntityId", "ActivityEntityId", "InfoPanel", "Labels", "Status", "Condition", "Criticality", "Maturity", "ProgressStatus", "Unplanned", "DateRange", "Attributes", "DashboardCategory"];
    }
}

export function SearchParams_$reflection() {
    return union_type("EPM.App.SearchParams", [], SearchParams, () => [[["Item", string_type]], [["Item", string_type]], [["Item1", class_type("System.Guid")], ["Item2", DomainEntities_$reflection()]], [["Item", class_type("System.Guid")]], [["Item", InfoPanel_$reflection()]], [["Item1", DomainEntities_$reflection()], ["Item2", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])]], [["Item", Status_$reflection()]], [["Item", Condition_$reflection()]], [["Item", Criticality_$reflection()]], [["Item", Maturity_$reflection()]], [["Item", string_type]], [["Item", bool_type]], [["Item", ActivityDateRange_$reflection()]], [["Item", list_type(string_type)]], [["Item", Action_Category_$reflection()]]]);
}

export function SearchParams__get_toKeyValue(this$) {
    let value;
    switch (this$.tag) {
        case 10:
            return ["progress", this$.fields[0]];
        case 6:
            return ["status", toString(this$.fields[0])];
        case 7:
            return ["condition", toString(this$.fields[0])];
        case 8:
            return ["criticality", toString(this$.fields[0])];
        case 0:
            return ["type", this$.fields[0]];
        case 1:
            return ["query", this$.fields[0]];
        case 4: {
            const panel = this$.fields[0];
            if (panel.tag === 0) {
                return ["ip", "project"];
            }
            else {
                return ["ip", `${panel.fields[0]}:${panel.fields[1]}`];
            }
        }
        case 2:
            return [SearchKey_singleDomainEntityKey(this$.fields[1]), this$.fields[0]];
        case 3:
            return ["entityId", this$.fields[0]];
        case 5:
            return [SearchKey_labelsKey(this$.fields[0]), labelsToUrl(this$.fields[1])];
        case 13:
            return ["attributes", attributesToUrl(this$.fields[0])];
        case 14:
            return ["dashboard-category", EPM_Domain_Events_Action_Category__Category_ToUrlString(this$.fields[0])];
        case 11:
            return ["unplanned", toString(this$.fields[0])];
        case 12: {
            const dateRange = this$.fields[0];
            return ["date-range", (value = ((dateRange.tag === 1) ? ((("completed=" + toString_1(dateRange.fields[0], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) + ";") + toString_1(dateRange.fields[1], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) : ((dateRange.tag === 2) ? ("expected=" + toString_1(dateRange.fields[0], "O")) : ((dateRange.tag === 3) ? ((("expected=" + toString_1(dateRange.fields[0], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) + ";") + toString_1(dateRange.fields[1], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) : ((dateRange.tag === 4) ? ((("falls-between=" + toString_1(dateRange.fields[0], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) + ";") + toString_1(dateRange.fields[1], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) : ((dateRange.tag === 5) ? ("falls-on=" + toString_1(dateRange.fields[0], "yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss")) : ("completed=" + toString_1(dateRange.fields[0], "O"))))))), encodeURIComponent(value))];
        }
        default:
            return ["maturity", EPM_Domain_Events_Maturity__Maturity_ToUrlString(this$.fields[0])];
    }
}

export function SearchParams_tryParse(key, value) {
    let values;
    switch (key) {
        case "query":
            if (isNullOrWhiteSpace(value)) {
                return undefined;
            }
            else {
                return new SearchParams(1, [decodeURIComponent(value)]);
            }
        case "type":
            return map_1((Item_1) => (new SearchParams(0, [Item_1])), EntityType_tryParse_Z721C83C5(value));
        case "ip":
            if (value === "project") {
                return new SearchParams(4, [new InfoPanel(0, [])]);
            }
            else {
                const matchValue = ofArray(split(value, [":"], 2, 0));
                let matchResult, entityId, entityType;
                if (!isEmpty(matchValue)) {
                    if (!isEmpty(tail(matchValue))) {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                            entityId = head(matchValue);
                            entityType = head(tail(matchValue));
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        const option_2 = System_Guid__Guid_tryParse_Static_Z721C83C5(entityId);
                        return map2((et, eId) => (new SearchParams(4, [new InfoPanel(1, [eId, et])])), DomainEntities_tryParse_Z721C83C5(entityType), option_2);
                    }
                    default:
                        return undefined;
                }
            }
        case "status":
            return map_1((Item_2) => (new SearchParams(6, [Item_2])), EPM_Domain_Events_Status__Status_tryParse_Static_Z721C83C5(value));
        case "condition":
            return map_1((Item_3) => (new SearchParams(7, [Item_3])), EPM_Domain_Events_Condition__Condition_tryParse_Static_Z721C83C5(value));
        case "criticality":
            return map_1((Item_4) => (new SearchParams(8, [Item_4])), EPM_Domain_Events_Criticality__Criticality_tryParse_Static_Z721C83C5(value));
        case "progress":
            return map_1((Item_5) => (new SearchParams(10, [Item_5])), ProgressStatus_tryParse_Z721C83C5(value));
        case "dashboard-category":
            return map_1((Item_6) => (new SearchParams(14, [Item_6])), EPM_Domain_Events_Action_Category__Category_tryParse_Static_Z721C83C5(value));
        case "maturity":
            return map_1((Item_7) => (new SearchParams(9, [Item_7])), EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5(value));
        case "entityId":
            return map_1((Item_8) => (new SearchParams(3, [Item_8])), System_Guid__Guid_tryParse_Static_Z721C83C5(value));
        case "attributes":
            return new SearchParams(13, [ofArray(map_2((value_2) => (decodeURIComponent(value_2)), split(decodeURIComponent(value), [";"], undefined, 0)))]);
        case "unplanned":
            return map_1((Item_10) => (new SearchParams(11, [Item_10])), System_Boolean__Boolean_tryParse_Static_Z721C83C5(value));
        case "date-range": {
            const parts = ofArray(split(decodeURIComponent(value), ["="], undefined, 0));
            return map_1((Item_14) => (new SearchParams(12, [Item_14])), !isEmpty(parts) ? (!isEmpty(tail(parts)) ? (isEmpty(tail(tail(parts))) ? ((values = ofArray(split(head(tail(parts)), [";"], undefined, 0)), (head(parts) === "expected") ? (!isEmpty(values) ? (!isEmpty(tail(values)) ? (isEmpty(tail(tail(values))) ? map2((ds_1, de_1) => (new ActivityDateRange(3, [ds_1, de_1])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values)), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(tail(values)))) : undefined) : map_1((Item_11) => (new ActivityDateRange(2, [Item_11])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values)))) : undefined) : ((head(parts) === "completed") ? (!isEmpty(values) ? (!isEmpty(tail(values)) ? (isEmpty(tail(tail(values))) ? map2((ds_3, de_3) => (new ActivityDateRange(1, [ds_3, de_3])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values)), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(tail(values)))) : undefined) : map_1((Item_12) => (new ActivityDateRange(0, [Item_12])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values)))) : undefined) : ((head(parts) === "falls-on") ? (!isEmpty(values) ? (isEmpty(tail(values)) ? map_1((Item_13) => (new ActivityDateRange(5, [Item_13])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values))) : undefined) : undefined) : ((head(parts) === "falls-between") ? (!isEmpty(values) ? (!isEmpty(tail(values)) ? (isEmpty(tail(tail(values))) ? map2((ds_5, de_5) => (new ActivityDateRange(4, [ds_5, de_5])), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(values)), System_DateTimeOffset__DateTimeOffset_tryParse_Static_Z721C83C5(head(tail(values)))) : undefined) : undefined) : undefined) : undefined))))) : undefined) : undefined) : undefined);
        }
        default: {
            const activePatternResult = StringPatterns_$007CStartsWithExtract$007C_$007C("labels", key);
            if (activePatternResult != null) {
                const domainEntity = activePatternResult;
                const domainEntityOpt = DomainEntities_tryParse_Z721C83C5(domainEntity);
                if (domainEntityOpt != null) {
                    const domainEntity_1 = domainEntityOpt;
                    const m = ofArray_1(choose((kv) => {
                        const matchValue_2 = ofArray(split(kv, ["="], 2, 0));
                        let matchResult_1, key_1, key_2, value_6;
                        if (!isEmpty(matchValue_2)) {
                            if (!isEmpty(tail(matchValue_2))) {
                                if (isEmpty(tail(tail(matchValue_2)))) {
                                    matchResult_1 = 1;
                                    key_2 = head(matchValue_2);
                                    value_6 = head(tail(matchValue_2));
                                }
                                else {
                                    matchResult_1 = 2;
                                }
                            }
                            else {
                                matchResult_1 = 0;
                                key_1 = head(matchValue_2);
                            }
                        }
                        else {
                            matchResult_1 = 2;
                        }
                        switch (matchResult_1) {
                            case 0:
                                return [decodeURIComponent(key_1), empty_1({
                                    Compare: comparePrimitives,
                                })];
                            case 1: {
                                const key_3 = decodeURIComponent(key_2);
                                const values_1 = ofArray_2(map_2((value_8) => (decodeURIComponent(value_8)), split(value_6, [","], undefined, 0)), {
                                    Compare: comparePrimitives,
                                });
                                if (FSharpSet__get_IsEmpty(values_1)) {
                                    return undefined;
                                }
                                else {
                                    return [key_3, values_1];
                                }
                            }
                            default:
                                return undefined;
                        }
                    }, map_2((value_4) => (decodeURIComponent(value_4)), split(decodeURIComponent(value), [";"], undefined, 0))), {
                        Compare: comparePrimitives,
                    });
                    if (FSharpMap__get_IsEmpty(m)) {
                        return undefined;
                    }
                    else {
                        return new SearchParams(5, [domainEntity_1, m]);
                    }
                }
                else {
                    return undefined;
                }
            }
            else {
                const domainOpt = SearchKey_tryParseSingleDomainEntityKey(key);
                return map_1((tupledArg) => (new SearchParams(2, [tupledArg[0], tupledArg[1]])), map2((a, b) => [a, b], System_Guid__Guid_tryParse_Static_Z721C83C5(value), domainOpt));
            }
        }
    }
}

export function SearchParams_fromMap_Z305ADAA2(map) {
    return choose_1((tupledArg) => SearchParams_tryParse(tupledArg[0], tupledArg[1]), toList(map));
}

export function SearchParams_toMap_180030EC(search) {
    return ofList(map_3(SearchParams__get_toKeyValue, search), {
        Compare: comparePrimitives,
    });
}

export function Entity__get_SearchParamInfoPanel(this$) {
    return new SearchParams(4, [new InfoPanel(1, [Entity__get_Id(this$), EntityType__get_DomainEntity(Entity__get_EntityType(this$))])]);
}

export function Entity__get_SearchParamEntityId(this$) {
    return new SearchParams(2, [Entity__get_Id(this$), EntityType__get_DomainEntity(Entity__get_EntityType(this$))]);
}

export function Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(queryParams, replace, keepIP) {
    let ipOpt, patternInput_1;
    const keepIP_1 = defaultArg(keepIP, false);
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    const currentQuery = patternInput[1];
    const queryMap = SearchParams_toMap_180030EC(queryParams);
    return Feliz_Router_Router__Router_formatPath_Static_Z400814D9(patternInput[0], replace ? (keepIP_1 ? ((ipOpt = tryPick((p) => {
        if (p.tag === 4) {
            return p.fields[0];
        }
        else {
            return undefined;
        }
    }, SearchParams_fromMap_Z305ADAA2(currentQuery)), (ipOpt != null) ? ((patternInput_1 = SearchParams__get_toKeyValue(new SearchParams(4, [ipOpt])), add(patternInput_1[0], patternInput_1[1], queryMap))) : queryMap)) : queryMap) : Map_merge(currentQuery, queryMap));
}

export function Feliz_Router_Router__Router_formatQueryAndPath_Static_Z6D0E1C21(newUrl, queryParams, replace) {
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    const queryMap = SearchParams_toMap_180030EC(queryParams);
    return Feliz_Router_Router__Router_formatPath_Static_Z400814D9(newUrl, replace ? queryMap : Map_merge(patternInput[1], queryMap));
}

export function Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(queryParams, replace, keepIP) {
    let ipOpt, patternInput_1;
    const keepIP_1 = defaultArg(keepIP, false);
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    const currentQuery = patternInput[1];
    const queryMap = SearchParams_toMap_180030EC(queryParams);
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput[0], replace ? (keepIP_1 ? ((ipOpt = tryPick((p) => {
        if (p.tag === 4) {
            return p.fields[0];
        }
        else {
            return undefined;
        }
    }, SearchParams_fromMap_Z305ADAA2(currentQuery)), (ipOpt != null) ? ((patternInput_1 = SearchParams__get_toKeyValue(new SearchParams(4, [ipOpt])), add(patternInput_1[0], patternInput_1[1], queryMap))) : queryMap)) : queryMap) : Map_merge(currentQuery, queryMap));
}

export function Feliz_Router_Router__Router_navigateQueryAndPath_Static_Z6D0E1C21(newUrl, queryParams, replace) {
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    const queryMap = SearchParams_toMap_180030EC(queryParams);
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(newUrl, replace ? queryMap : Map_merge(patternInput[1], queryMap));
}

export function Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC(queryParams) {
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput[0], SearchParams_toMap_180030EC(List_except(queryParams, SearchParams_fromMap_Z305ADAA2(patternInput[1]), {
        Equals: equals,
        GetHashCode: safeHash,
    })));
}

export function Feliz_Router_Router__Router_navigateQueryPathExclude_Static_7F866359(queryParams) {
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput[0], filter((key, _arg) => !contains(key, queryParams, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), patternInput[1]));
}

export function AdminPage__get_Name(this$) {
    switch (this$) {
        case "system":
            return "Systems";
        case "subsystem":
            return "Subsystems";
        case "facility":
            return "Facilities";
        case "discipline":
            return "Disciplines";
        case "activity":
            return "Activities";
        case "documentTracking":
            return "Documents Tracking";
        case "certificate":
            return "Certificates";
        case "preservation":
            return "Preservation";
        case "punchList":
            return "Punch Lists";
        case "technicalQuery":
            return "Technical Queries";
        case "module":
            return "Modules";
        case "area":
            return "Areas";
        case "location":
            return "Locations";
        case "document":
            return "Documents";
        case "equipmentType":
            return "Equipment Types";
        case "action":
            return "Actions";
        case "actionType":
            return "Action Types";
        case "productionUnit":
            return "Production Units";
        case "productionUnitType":
            return "Production Unit Types";
        case "user":
            return "Users";
        case "job":
            return "Jobs";
        default:
            return "Tags";
    }
}

export class ProjectPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Definition", "Dashboard", "Progress", "Model", "Admin", "QRCode"];
    }
}

export function ProjectPage_$reflection() {
    return union_type("EPM.App.ProjectPage", [], ProjectPage, () => [[["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item1", class_type("System.Guid")], ["Item2", string_type]], [["Item1", class_type("System.Guid")], ["Item2", string_type]], [["Item1", class_type("System.Guid")], ["Item2", class_type("System.Guid")], ["Item3", DomainEntities_$reflection()]]]);
}

export function ProjectPage_CreateQRCodeUrl(projectId, domainEntity, entityId) {
    return `${window.location.origin}/projects/${projectId}/${toString(domainEntity)}/${entityId}`;
}

export function ProjectPage__get_ProjectId(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0];
        case 2:
            return this$.fields[0];
        case 3:
            return this$.fields[0];
        case 4:
            return this$.fields[0];
        case 5:
            return this$.fields[0];
        case 6:
            return this$.fields[0];
        default:
            return this$.fields[0];
    }
}

export function ProjectPage__get_UrlSegments(this$) {
    switch (this$.tag) {
        case 1:
            return [ofArray(["projects", this$.fields[0], "definition"]), empty_2()];
        case 2:
            return [ofArray(["projects", this$.fields[0], "dashboard"]), singleton(new SearchParams(0, ["scopeOfWork"]))];
        case 3:
            return [ofArray(["projects", this$.fields[0], "progress"]), empty_2()];
        case 4:
            return [ofArray(["projects", this$.fields[0], "model", this$.fields[1]]), empty_2()];
        case 5:
            return [ofArray(["projects", this$.fields[0], "admin", this$.fields[1]]), empty_2()];
        case 6:
            return [ofArray(["projects", this$.fields[0]]), singleton(new SearchParams(4, [new InfoPanel(1, [this$.fields[1], this$.fields[2]])]))];
        default:
            return [ofArray(["projects", this$.fields[0]]), empty_2()];
    }
}

export function ProjectPage__get_Href(this$) {
    const patternInput = ProjectPage__get_UrlSegments(this$);
    return Feliz_Router_Router__Router_formatPath_Static_Z400814D9(patternInput[0], SearchParams_toMap_180030EC(patternInput[1]));
}

export function ProjectPage__get_HrefPreserveQuery(this$) {
    const patternInput = ProjectPage__get_UrlSegments(this$);
    return Feliz_Router_Router__Router_formatQueryAndPath_Static_Z6D0E1C21(patternInput[0], patternInput[1], false);
}

export function ProjectPage__Navigate(this$) {
    const patternInput = ProjectPage__get_UrlSegments(this$);
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput[0], SearchParams_toMap_180030EC(patternInput[1]));
}

export function ProjectPage__NavigatePreserveQuery(this$) {
    const patternInput = ProjectPage__get_UrlSegments(this$);
    Feliz_Router_Router__Router_navigateQueryAndPath_Static_Z6D0E1C21(patternInput[0], patternInput[1], false);
}

export function ProjectPage__OnClick_Z11029FF1(this$, e) {
    e.preventDefault();
    ProjectPage__Navigate(this$);
}

export function ProjectPage__OnClickPreserveQuery_Z11029FF1(this$, e) {
    e.preventDefault();
    ProjectPage__NavigatePreserveQuery(this$);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Projects", "Project", "NotFound", "Auth"];
    }
}

export function Page_$reflection() {
    return union_type("EPM.App.Page", [], Page, () => [[], [["Item", ProjectPage_$reflection()]], [], []]);
}

export function Page__get_UrlSegments(this$) {
    switch (this$.tag) {
        case 1:
            return ProjectPage__get_UrlSegments(this$.fields[0]);
        case 2:
            return [singleton("NotFound"), empty_2()];
        case 3:
            throw new Error("Should not route to this url");
        default:
            return [empty_2(), empty_2()];
    }
}

export function Page__get_Href(this$) {
    const patternInput = Page__get_UrlSegments(this$);
    return Feliz_Router_Router__Router_formatPath_Static_Z400814D9(patternInput[0], SearchParams_toMap_180030EC(patternInput[1]));
}

export function Page__Navigate(this$) {
    const patternInput = Page__get_UrlSegments(this$);
    Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput[0], SearchParams_toMap_180030EC(patternInput[1]));
}

export function Page__OnClick_Z11029FF1(this$, e) {
    e.preventDefault();
    Page__Navigate(this$);
}

export class BackgroundImage extends Record {
    constructor(Width, Url) {
        super();
        this.Width = (Width | 0);
        this.Url = Url;
    }
}

export function BackgroundImage_$reflection() {
    return record_type("EPM.App.BackgroundImage", [], BackgroundImage, () => [["Width", int32_type], ["Url", string_type]]);
}

export function BackgroundImage_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new BackgroundImage((objectArg = get$.Required, objectArg.Field("width", uncurry2(int))), (objectArg_1 = get$.Required, objectArg_1.Field("url", string)));
    }, path_1, v));
}

export function BackgroundImage_Encoder_703E2475(backgroundImage) {
    return object_1([["width", backgroundImage.Width], ["url", backgroundImage.Url]]);
}

export class Annotation extends Record {
    constructor(Id, Type, AnnotationIndex) {
        super();
        this.Id = Id;
        this.Type = Type;
        this.AnnotationIndex = (AnnotationIndex | 0);
    }
}

export function Annotation_$reflection() {
    return record_type("EPM.App.Annotation", [], Annotation, () => [["Id", class_type("System.Guid")], ["Type", DomainEntities_$reflection()], ["AnnotationIndex", int32_type]]);
}

export function Annotation_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg, arg_3, objectArg_1, objectArg_2;
        return new Annotation((objectArg = get$.Required, objectArg.Field("id", guid)), (arg_3 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg_1 = get$.Required, objectArg_1.Field("type", uncurry2(arg_3)))), (objectArg_2 = get$.Required, objectArg_2.Field("annotation", uncurry2(int))));
    }, path_1, v));
}

export function Annotation_Encoder_Z36B7FF25(annotation) {
    return object_1([["id", guid_1(annotation.Id)], ["annotation", annotation.AnnotationIndex], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(annotation.Type)]]);
}

export class Model extends Record {
    constructor(SketchfabId, Name, SketchFabAnnotations) {
        super();
        this.SketchfabId = SketchfabId;
        this.Name = Name;
        this.SketchFabAnnotations = SketchFabAnnotations;
    }
}

export function Model_$reflection() {
    return record_type("EPM.App.Model", [], Model, () => [["SketchfabId", string_type], ["Name", string_type], ["SketchFabAnnotations", list_type(Annotation_$reflection())]]);
}

export function Model_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, arg_5, decoder, objectArg_2;
        return new Model((objectArg = get$.Required, objectArg.Field("sketchfabId", string)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)), (arg_5 = ((decoder = Annotation_get_Decoder(), (path_2) => ((value_2) => list_4(uncurry2(decoder), path_2, value_2)))), (objectArg_2 = get$.Required, objectArg_2.Field("sketchfabAnnotations", uncurry2(arg_5)))));
    }, path_3, v));
}

export function Model_Encoder_541DC133(model) {
    return object_1([["sketchfabId", model.SketchfabId], ["name", model.Name], ["sketchfabAnnotations", list_5(map_3(Annotation_Encoder_Z36B7FF25, model.SketchFabAnnotations))]]);
}

export class CustomTile extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TagsByEquipmentTypeId", "TagsByLabel"];
    }
}

export function CustomTile_$reflection() {
    return union_type("EPM.App.CustomTile", [], CustomTile, () => [[["Item", class_type("System.Guid")]], [["Item1", string_type], ["Item2", string_type]]]);
}

export function CustomTile_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_1, objectArg_2, objectArg_3;
        let tileType;
        const objectArg = get$.Required;
        tileType = objectArg.Field("type", string);
        switch (tileType) {
            case "TagsByLabel":
                return new CustomTile(1, [(objectArg_1 = get$.Required, objectArg_1.Field("key", string)), (objectArg_2 = get$.Required, objectArg_2.Field("value", string))]);
            case "TagsByEquipmentType":
                return new CustomTile(0, [(objectArg_3 = get$.Required, objectArg_3.Field("equipmentTypeId", guid))]);
            default:
                throw new Error(`Unrecognised custom tile type: ${tileType}`);
        }
    }, path_4, v));
}

export function CustomTile_Encoder_135254DB(tile) {
    if (tile.tag === 1) {
        return object_1([["type", "TagsByLabel"], ["key", tile.fields[0]], ["value", tile.fields[1]]]);
    }
    else {
        return object_1([["type", "TagsByEquipmentType"], ["equipmentTypeId", guid_1(tile.fields[0])]]);
    }
}

export class ProjectWall extends Record {
    constructor(CustomTiles) {
        super();
        this.CustomTiles = CustomTiles;
    }
}

export function ProjectWall_$reflection() {
    return record_type("EPM.App.ProjectWall", [], ProjectWall, () => [["CustomTiles", list_type(CustomTile_$reflection())]]);
}

export function ProjectWall_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let arg_1, decoder, objectArg;
        return new ProjectWall((arg_1 = ((decoder = CustomTile_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg = get$.Required, objectArg.Field("customTiles", uncurry2(arg_1)))));
    }, path_1, v));
}

export function ProjectWall_Encoder_29F378DF(projectWall) {
    return object_1([["customTiles", list_5(map_3(CustomTile_Encoder_135254DB, projectWall.CustomTiles))]]);
}

export class Walkthrough extends Record {
    constructor(EntityId, Url) {
        super();
        this.EntityId = EntityId;
        this.Url = Url;
    }
}

export function Walkthrough_$reflection() {
    return record_type("EPM.App.Walkthrough", [], Walkthrough, () => [["EntityId", class_type("System.Guid")], ["Url", string_type]]);
}

export function Walkthrough_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Walkthrough((objectArg = get$.Required, objectArg.Field("entityId", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("url", string)));
    }, path_2, v));
}

export function Walkthrough_Encoder_25FBBDF6(walkthrough) {
    return object_1([["entityId", guid_1(walkthrough.EntityId)], ["url", walkthrough.Url]]);
}

export class PanelData extends Record {
    constructor(Name, Value, Url) {
        super();
        this.Name = Name;
        this.Value = Value;
        this.Url = Url;
    }
}

export function PanelData_$reflection() {
    return record_type("EPM.App.PanelData", [], PanelData, () => [["Name", string_type], ["Value", string_type], ["Url", option_type(string_type)]]);
}

export function PanelData_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new PanelData((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("value", string)), (objectArg_2 = get$.Optional, objectArg_2.Field("url", string)));
    }, path_3, v));
}

export function PanelData_Encoder_Z25B0F726(panelData) {
    return object_1([["name", panelData.Name], ["value", panelData.Value], ["url", option_17((value_2) => value_2)(panelData.Url)]]);
}

export class PanelSection extends Record {
    constructor(Name, Values) {
        super();
        this.Name = Name;
        this.Values = Values;
    }
}

export function PanelSection_$reflection() {
    return record_type("EPM.App.PanelSection", [], PanelSection, () => [["Name", string_type], ["Values", list_type(PanelData_$reflection())]]);
}

export function PanelSection_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, arg_3, decoder, objectArg_1;
        return new PanelSection((objectArg = get$.Required, objectArg.Field("name", string)), (arg_3 = ((decoder = PanelData_get_Decoder(), (path_1) => ((value_1) => list_4(uncurry2(decoder), path_1, value_1)))), (objectArg_1 = get$.Required, objectArg_1.Field("values", uncurry2(arg_3)))));
    }, path_2, v));
}

export function PanelSection_Encoder_Z3082D1DD(panelSection) {
    return object_1([["name", panelSection.Name], ["values", list_5(map_3(PanelData_Encoder_Z25B0F726, panelSection.Values))]]);
}

export class ProjectConfig extends Record {
    constructor(Name, Description, ImageUrl, BackgroundImages, Walkthrough, ProjectWall, ProjectInfoPanel, Models) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.BackgroundImages = BackgroundImages;
        this.Walkthrough = Walkthrough;
        this.ProjectWall = ProjectWall;
        this.ProjectInfoPanel = ProjectInfoPanel;
        this.Models = Models;
    }
}

export function ProjectConfig_$reflection() {
    return record_type("EPM.App.ProjectConfig", [], ProjectConfig, () => [["Name", string_type], ["Description", option_type(string_type)], ["ImageUrl", option_type(string_type)], ["BackgroundImages", list_type(BackgroundImage_$reflection())], ["Walkthrough", list_type(Walkthrough_$reflection())], ["ProjectWall", option_type(ProjectWall_$reflection())], ["ProjectInfoPanel", list_type(PanelSection_$reflection())], ["Models", list_type(Model_$reflection())]]);
}

export function ProjectConfig_get_Decoder() {
    return (path_10) => ((v) => object((get$) => {
        let objectArg, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, arg_21, decoder_2, objectArg_10, arg_23, decoder_3, objectArg_11;
        const projectName = defaultArgWith((objectArg = get$.Optional, objectArg.Field("ProjectName", string)), () => {
            const objectArg_1 = get$.Required;
            return objectArg_1.Field("name", string);
        });
        const projectDescription = orElse((objectArg_2 = get$.Optional, objectArg_2.Field("ProjectDescription", string)), (objectArg_3 = get$.Optional, objectArg_3.Field("description", string)));
        const image = orElse(orElse((objectArg_4 = get$.Optional, objectArg_4.Field("ImageUrl", string)), (objectArg_5 = get$.Optional, objectArg_5.Field("imageUrl", string))), map_1((imageId) => (`https://epmdata.blob.core.windows.net/assets/images/${imageId}.jpg`), (objectArg_6 = get$.Optional, objectArg_6.Field("Image ID", uncurry2(int)))));
        let models;
        let arg_15;
        const decoder = Model_get_Decoder();
        arg_15 = ((path_6) => ((value_6) => list_4(uncurry2(decoder), path_6, value_6)));
        const objectArg_7 = get$.Optional;
        models = objectArg_7.Field("models", uncurry2(arg_15));
        let walkthrough;
        let arg_17;
        const decoder_1 = Walkthrough_get_Decoder();
        arg_17 = ((path_7) => ((value_7) => list_4(uncurry2(decoder_1), path_7, value_7)));
        const objectArg_8 = get$.Optional;
        walkthrough = objectArg_8.Field("walkthrough", uncurry2(arg_17));
        let projectWall;
        const arg_19 = ProjectWall_get_Decoder();
        const objectArg_9 = get$.Optional;
        projectWall = objectArg_9.Field("projectWall", uncurry2(arg_19));
        const ProjectInfoPanel = defaultArg((arg_21 = ((decoder_2 = PanelSection_get_Decoder(), (path_8) => ((value_8) => list_4(uncurry2(decoder_2), path_8, value_8)))), (objectArg_10 = get$.Optional, objectArg_10.Field("projectInfoPanel", uncurry2(arg_21)))), empty_2());
        const Walkthrough_1 = defaultArg(walkthrough, empty_2());
        const Models = defaultArg(models, empty_2());
        return new ProjectConfig(projectName, projectDescription, image, defaultArg((arg_23 = ((decoder_3 = BackgroundImage_get_Decoder(), (path_9) => ((value_12) => list_4(uncurry2(decoder_3), path_9, value_12)))), (objectArg_11 = get$.Optional, objectArg_11.Field("background", uncurry2(arg_23)))), empty_2()), Walkthrough_1, projectWall, ProjectInfoPanel, Models);
    }, path_10, v));
}

export function ProjectConfig_Encoder_4562D323(projectConfig) {
    return object_1([["name", projectConfig.Name], ["description", option_17((value_1) => value_1)(projectConfig.Description)], ["imageUrl", option_17((value_3) => value_3)(projectConfig.ImageUrl)], ["projectWall", option_17(ProjectWall_Encoder_29F378DF)(projectConfig.ProjectWall)], ["projectInfoPanel", list_5(map_3(PanelSection_Encoder_Z3082D1DD, projectConfig.ProjectInfoPanel))], ["walkthrough", list_5(map_3(Walkthrough_Encoder_25FBBDF6, projectConfig.Walkthrough))], ["models", list_5(map_3(Model_Encoder_541DC133, projectConfig.Models))], ["background", list_5(map_3(BackgroundImage_Encoder_703E2475, projectConfig.BackgroundImages))]]);
}

export class Profile extends Record {
    constructor(epmId, projects, globalPermissions) {
        super();
        this.epmId = epmId;
        this.projects = projects;
        this.globalPermissions = globalPermissions;
    }
}

export function Profile_$reflection() {
    return record_type("EPM.App.Profile", [], Profile, () => [["epmId", class_type("System.Guid")], ["projects", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), Users_Project_$reflection()])], ["globalPermissions", list_type(Scope_$reflection())]]);
}

export function Profile__ProjectPermissions_244AC511(this$, projectId) {
    const matchValue = FSharpMap__TryFind(this$.projects, projectId);
    if (matchValue != null) {
        return append(matchValue.Permissions, this$.globalPermissions);
    }
    else {
        return this$.globalPermissions;
    }
}

export function Profile__HasAccessToAdmin_244AC511(this$, projectId) {
    return exists(Types_Scope__Scope_get_HasAccessToAdmin, Profile__ProjectPermissions_244AC511(this$, projectId));
}

export function Profile_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1, arg_5, decoder, objectArg_2;
        return new Profile((objectArg = get$.Required, objectArg.Field("epmId", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("projects", uncurry2(Users_projectsDecoder))), (arg_5 = ((decoder = Scope_get_Decoder(), (path_1) => ((value_1) => list_4(uncurry2(decoder), path_1, value_1)))), (objectArg_2 = get$.Required, objectArg_2.Field("globalPermissions", uncurry2(arg_5)))));
    }, path_2, v));
}

export class Payload extends Record {
    constructor(profile) {
        super();
        this.profile = profile;
    }
}

export function Payload_$reflection() {
    return record_type("EPM.App.Payload", [], Payload, () => [["profile", Profile_$reflection()]]);
}

export function Payload_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Payload((arg_1 = Profile_get_Decoder(), (objectArg = get$.Required, objectArg.Field("https://epm.unasys.com/profile", uncurry2(arg_1)))));
    }, path, v));
}

export class User extends Record {
    constructor(name, picture) {
        super();
        this.name = name;
        this.picture = picture;
    }
}

export function User_$reflection() {
    return record_type("EPM.App.User", [], User, () => [["name", string_type], ["picture", string_type]]);
}

export function EPM_Domain_Events_Action_Category__Category_get_EntityType(this$) {
    switch (this$.tag) {
        case 1:
            return "certification";
        case 2:
            return "punchList";
        case 3:
            return "documentTracking";
        case 4:
            return "preservation";
        case 5:
            return "technicalQuery";
        case 6:
            return "nonConformanceReport";
        default:
            return "activity";
    }
}

